import React from 'react';
import styled from 'styled-components';
import { DataContext } from '../DataProvider';
import { UserContext } from '../UserProvider';

import { updateLessonCompleteEndpoint, goToNextLesson } from '../../utils';

function VideoPlayer() {
  const {
    lessons,
    videoUrl,
    selectedVideoId,
    selectedEpisodeNumber,
    setCourseProgress,
    selectedCourse,
    setSelectedVideoId,
    setSelectedEpisodeNumber,
    setSelectedQuizId,
    setApiWasRequested,
    setRequestWasHandled,
    setExerciseWasRequested,
    setExerciseWasFetched,
    setExerciseData,
    setSelectedExerciseIndex,
    setCurrPositionIndex,
  } = React.useContext(DataContext);
  const { token } = React.useContext(UserContext);

  const handleVideoEnd = () => {
    var alreadyAdvancedSection = false;
    setExerciseData(null);
    setCourseProgress((oldCourseProgress) => {
      const newCourseProgress = { ...oldCourseProgress };
      setSelectedExerciseIndex(0);
      setCurrPositionIndex(0);
      Object.keys(newCourseProgress).forEach((section) => {
        const updatedSection = newCourseProgress[section].map((lesson) => {
          if (
            lesson.episode_number &&
            lesson.episode_number === selectedEpisodeNumber
          ) {
            updateLessonCompleteEndpoint(
              selectedCourse,
              section,
              lesson.episode_number,
              'COMPLETE',
              token
            );
            if (!alreadyAdvancedSection) {
              goToNextLesson(
                lessons,
                lesson,
                setSelectedVideoId,
                setSelectedEpisodeNumber,
                setSelectedQuizId,
                setApiWasRequested,
                setRequestWasHandled,
                setExerciseWasRequested,
                setExerciseWasFetched
              );
              alreadyAdvancedSection = true;
            }

            return { ...lesson, status: 'COMPLETE' };
          }
          return lesson;
        });
        newCourseProgress[section] = updatedSection;
      });
      return newCourseProgress;
    });
  };

  const defaultVid = 'https://000-public-jshapiro.s3.amazonaws.com/ytmnd.mp4';
  const videoSrc = videoUrl !== '' ? videoUrl : defaultVid;

  if (selectedVideoId !== '' && selectedVideoId !== undefined) {
    return (
      <VideoContainer>
        <StyledVideo
          src={videoSrc}
          controls
          autoPlay
          onEnded={handleVideoEnd}
        />
      </VideoContainer>
    );
  } else {
    return <div></div>;
  }
}

export default VideoPlayer;

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const StyledVideo = styled.video`
  width: 100%;
  height: auto;
  max-height: 100%;
`;
